import api from "./api";

// Staff assigning/reassigning technicians to a work order. These hit dedicated
// wo:assignTech-gated endpoints (assign_*) rather than the shared create/delete/
// update_bulk_technician endpoints, which stay open for the technician app.
const createTechnician = (data) => {
  return api.post("/api/technician/assign_create", data);
};

const updateBulkTechnician = (data) => {
  return api.post("/api/technician/assign_update_bulk", data);
};

const deleteTechnician = (data) => {
  return api.post("/api/technician/assign_delete", data);
};

const update = data => {
  return api.post('/api/technician/update', data);
};

// Staff logging/editing a technician's timesheet from the WO detail page. Hits a
// dedicated wo:logTimesheet-gated endpoint; the shared /update stays open for the
// technician app, which submits its own timesheet without staff permissions.
// A technician's own hours on a work order (no wo:logTimesheet): only their
// own assignment, under the tech app's rules.
const updateOwnTimesheet = (data) => {
  return api.post("/api/technician/update_timesheet_own", data);
};

const updateTimesheet = data => {
  return api.post('/api/technician/update_timesheet_staff', data);
};

const getTimesheetByWoId = (woId) => {
  return api.get('/api/technician/get_timesheet_by_wo_id', { params: { woId } });
};

const getStatusBoard = (branch) => {
  return api.get('/api/technician/get_status_board', { params: { branch } });
};

// A job offered to this technician (the tech app's Requests tab).
const acceptOrder = (data) => {
  return api.post("/api/technician/accept_order", data);
};

const rejectOrder = (data) => {
  return api.post("/api/technician/reject_order", data);
};

const TechnicianService = {
  acceptOrder,
  rejectOrder,
  update,
  updateTimesheet,
  updateOwnTimesheet,
  createTechnician,
  updateBulkTechnician,
  deleteTechnician,
  getTimesheetByWoId,
  getStatusBoard,
};

export default TechnicianService;
